var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _vm.createdAt
      ? _c(
          "p",
          { staticClass: "text-sm leading-6 font-400 text-gray-new mb-4" },
          [_vm._v(" Visit created: " + _vm._s(_vm.createdAt) + " ")]
        )
      : _vm._e(),
    _c(
      "form",
      {
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.handleSubmit(_vm.submit)
          },
        },
      },
      [
        _c("ValidationObserver", {
          scopedSlots: _vm._u(
            [
              {
                key: "default",
                fn: function ({ invalid, dirty, errors, handleSubmit }) {
                  return [
                    _vm.showProject && !_vm.isEdit
                      ? _c("ValidationProvider", {
                          attrs: { name: "Client", rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function ({ errors, failed }) {
                                  return [
                                    _c(
                                      "FormGroup",
                                      {
                                        staticClass: "mb-4",
                                        attrs: { errors: errors },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "title",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "p",
                                                    { staticClass: "mb-2" },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "required-icon",
                                                        },
                                                        [_vm._v("*")]
                                                      ),
                                                      _vm._v(" Client"),
                                                    ]
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [
                                        _c("ProjectsMultiselect", {
                                          attrs: {
                                            single: "",
                                            invalid: failed,
                                            projectsConditions:
                                              _vm.projectsConditions,
                                            disabled: _vm.isEdittingLocked,
                                            getcontainerStyle:
                                              "customWidthInput",
                                          },
                                          on: {
                                            input:
                                              _vm.onProjectSelectionChanged,
                                          },
                                          model: {
                                            value: _vm.chosenProjectId,
                                            callback: function ($$v) {
                                              _vm.chosenProjectId = $$v
                                            },
                                            expression: "chosenProjectId",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                    !_vm.shouldHideClientSelection
                      ? _c(
                          "FormGroup",
                          {
                            attrs: { errors: errors },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "title",
                                  fn: function () {
                                    return [
                                      _c("p", { staticClass: "mb-2" }, [
                                        _vm._v(" Assign a Resource "),
                                        _vm.isEdit
                                          ? _c(
                                              "span",
                                              { staticClass: "subAsignee" },
                                              [
                                                _vm._v(
                                                  " (If you're reassigning this visit, be sure to notify the previous assignee—they won’t receive an automatic update that they've been removed) "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            _vm.shouldUseSmartMatchComponent
                              ? _c("ContractorsMultiselectWithBookmarks", {
                                  staticClass: "mb-4",
                                  attrs: {
                                    placeholder:
                                      "Select assignee - bookmarked version",
                                    getParentcontainerStyle: "customWidthInput",
                                    noOptionsText: "No assignee",
                                    withBorder: false,
                                    invalid: _vm.failed,
                                    multiple: false,
                                    disabled: _vm.isEdittingLocked,
                                    "bookmarked-users": _vm.projectBookmarks,
                                  },
                                  on: { input: _vm.getContractorID },
                                  model: {
                                    value: _vm.activity.selectedContractorsIds,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.activity,
                                        "selectedContractorsIds",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "activity.selectedContractorsIds",
                                  },
                                })
                              : _c("ContractorsMultiselect", {
                                  staticClass: "mb-4",
                                  attrs: {
                                    placeholder: "Select assignee",
                                    getParentcontainerStyle: "customWidthInput",
                                    noOptionsText: "No assignee",
                                    withBorder: false,
                                    invalid: _vm.failed,
                                    multiple: false,
                                    disabled: _vm.isEdittingLocked,
                                  },
                                  on: { input: _vm.getContractorID },
                                  model: {
                                    value: _vm.activity.selectedContractorsIds,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.activity,
                                        "selectedContractorsIds",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "activity.selectedContractorsIds",
                                  },
                                }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.shouldShowNonSchedulingErrorNotifications
                      ? _c("VisitErrorNotificationContainer", {
                          staticClass: "mb-4",
                          attrs: {
                            errors: _vm.nonSchedulingValidationErrors,
                            show: _vm.shouldShowNonSchedulingErrorNotifications,
                          },
                        })
                      : _vm._e(),
                    _vm.showJobTitle
                      ? _c(
                          "div",
                          [
                            _c("ValidationProvider", {
                              attrs: { name: "Job title", rules: "max:100" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ errors }) {
                                      return [
                                        _c("FormGroup", {
                                          staticClass: "mb-4",
                                          attrs: {
                                            id: "title",
                                            title: "Job Title",
                                            name: "job title",
                                            placeholder: "Please start typing",
                                            disabled: _vm.isJobTitleDisabled,
                                            errors: errors,
                                            isIcon: false,
                                            inputClass: "fullwidthInput",
                                          },
                                          model: {
                                            value: _vm.jobTitle,
                                            callback: function ($$v) {
                                              _vm.jobTitle = $$v
                                            },
                                            expression: "jobTitle",
                                          },
                                        }),
                                        _c(
                                          "p",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: !_vm.isJobTitleDisabled,
                                                expression:
                                                  "!isJobTitleDisabled",
                                              },
                                            ],
                                            staticClass:
                                              "subjobTitle mt-1.5 mb-4",
                                          },
                                          [
                                            _vm._v(
                                              " To assign a job title please enter it above. This will reflect on the resource profile. "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      { staticClass: "flex flex-col justify-between" },
                      [
                        _c("p", { staticClass: "mb-2" }, [
                          _c("span", { staticClass: "required-icon" }, [
                            _vm._v("*"),
                          ]),
                          _vm._v("Date of Visit"),
                        ]),
                        _c(
                          "div",
                          { staticClass: "flex flex-row gap-7" },
                          [
                            _c("ValidationProvider", {
                              staticClass: "w-full",
                              attrs: {
                                vid: "start_date",
                                name: "Date of visit",
                                rules: "required",
                                immediate: !!_vm.projectActivity,
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ errors, failed }) {
                                      return [
                                        _c(
                                          "FormGroup",
                                          {
                                            staticClass: "mb-4",
                                            attrs: { errors: errors },
                                          },
                                          [
                                            _c("FormDatepicker", {
                                              attrs: {
                                                calendarClass: "",
                                                placeholder:
                                                  "Select date of visit",
                                                invalid: failed,
                                                heightClass: "datePickerHeight",
                                                isCalenderIcon: true,
                                                disabled: _vm.isEdittingLocked,
                                                customInputClass: true,
                                                disabledDates:
                                                  _vm.disabledDates,
                                              },
                                              model: {
                                                value: _vm.activity.startDate,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.activity,
                                                    "startDate",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "activity.startDate",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "flex w-full flex-col justify-between" },
                      [
                        _c("p", { staticClass: "mb-2" }, [
                          _c("span", { staticClass: "required-icon" }, [
                            _vm._v("*"),
                          ]),
                          _vm._v("Time of visit"),
                        ]),
                        _c("div", { staticClass: "flex flex-row m-0 gap-7" }, [
                          _c(
                            "div",
                            { staticClass: "w-1/2" },
                            [
                              _c("ValidationProvider", {
                                attrs: {
                                  name: "Start Time",
                                  rules: "required",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ failed, errors }) {
                                        return [
                                          _c(
                                            "FormGroup",
                                            { attrs: { errors: errors } },
                                            [
                                              _c("NewTimePicker", {
                                                attrs: {
                                                  format: "HH:mm",
                                                  placeholder:
                                                    "Select start time",
                                                  customControlStyle:
                                                    "rightControl",
                                                  "auto-scroll": "failed",
                                                  "is-empty": failed,
                                                  invalid: failed,
                                                  "advanced-keyboard": "",
                                                  "input-width": "100%",
                                                  "input-class":
                                                    "appearance-none customVisits border text-sm rounded-lg py-2.5 px-3 leading-tight focus:outline-none focus:shadow-outline scrollbar",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "icon",
                                                      fn: function () {
                                                        return [
                                                          _c("ClockIcon", {
                                                            staticClass:
                                                              "w-4 h-4 timepicker-icon",
                                                          }),
                                                        ]
                                                      },
                                                      proxy: true,
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                                model: {
                                                  value:
                                                    _vm.activity.start_time,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.activity,
                                                      "start_time",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "activity.start_time",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "w-1/2" },
                            [
                              _c("NewTimePicker", {
                                attrs: {
                                  format: "HH:mm",
                                  "auto-scroll:": "failed",
                                  placeholder: "Select end time",
                                  "advanced-keyboard": "",
                                  "input-width": "100%",
                                  customControlStyle: "rightControl",
                                  "hide-disabled-items": "",
                                  disabled: !_vm.activity.start_time,
                                  hourRange: _vm.rangeEndHourRange,
                                  minuteRange: _vm.rangeEndMinuteRange,
                                  "input-class":
                                    "appearance-none customVisits border text-sm rounded-lg py-2.5 px-3 leading-tight focus:outline-none focus:shadow-outline scrollbar",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "icon",
                                      fn: function () {
                                        return [
                                          _c("ClockIcon", {
                                            staticClass: "w-4 h-4",
                                          }),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  true
                                ),
                                model: {
                                  value: _vm.activity.end_time,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.activity, "end_time", $$v)
                                  },
                                  expression: "activity.end_time",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                        _c(
                          "div",
                          { staticClass: "flex items-center gap-2 mb-4" },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.disableTimeAlerts,
                                  expression: "disableTimeAlerts",
                                },
                              ],
                              staticClass:
                                "w-4 h-4 rounded border-gray-300 text-primary-500 focus:ring-primary-500",
                              attrs: {
                                type: "checkbox",
                                id: "disable-time-alerts",
                                disabled: _vm.isEdittingLocked,
                              },
                              domProps: {
                                checked: Array.isArray(_vm.disableTimeAlerts)
                                  ? _vm._i(_vm.disableTimeAlerts, null) > -1
                                  : _vm.disableTimeAlerts,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = _vm.disableTimeAlerts,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.disableTimeAlerts = $$a.concat([
                                          $$v,
                                        ]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.disableTimeAlerts = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.disableTimeAlerts = $$c
                                  }
                                },
                              },
                            }),
                            _c(
                              "label",
                              {
                                staticClass:
                                  "text-sm font-medium cursor-pointer select-none",
                                class: _vm.disableTimeAlerts
                                  ? "text-gray-500"
                                  : "text-gray-900",
                                attrs: { for: "disable-time-alerts" },
                              },
                              [_vm._v(" Disable time based alerts ")]
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm.shouldShowSchedulingErrorNotifications
                      ? _c("VisitErrorNotificationContainer", {
                          staticClass: "mb-4",
                          attrs: {
                            errors: _vm.schedulingValidationErrors,
                            show: _vm.shouldShowSchedulingErrorNotifications,
                          },
                        })
                      : _vm._e(),
                    _c(
                      "div",
                      { staticClass: "mb-4" },
                      [
                        _c("ValidationObserver", {
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function ({ failed, errors }) {
                                  return [
                                    _c(
                                      "FormGroup",
                                      {
                                        attrs: {
                                          title: "",
                                          "aria-required": "",
                                          name: "TypeOfVisit",
                                          getParentStyle: "customWidthInput",
                                          errors: errors,
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "title",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "p",
                                                    { staticClass: "mb-2" },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "required-icon",
                                                        },
                                                        [_vm._v("*")]
                                                      ),
                                                      _vm._v(" Activity"),
                                                    ]
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [
                                        _c("TypeOfVisitMultiselect", {
                                          attrs: {
                                            invalid: failed,
                                            getcontainerStyle:
                                              "customWidthInput",
                                            selectedTypeOfVisitId:
                                              _vm.activity.type_of_visit,
                                          },
                                          on: { input: _vm.updateTypeOfVisit },
                                          model: {
                                            value: _vm.activity.type_of_visit,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.activity,
                                                "type_of_visit",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "activity.type_of_visit",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      [
                        _c("LocationModal", {
                          attrs: {
                            location: _vm.activity.location,
                            checkGeo: _vm.activity.check_geo,
                            isClient: false,
                          },
                          on: {
                            locationAdded: _vm.locationAdded,
                            checkGeoChanged: _vm.onCheckGeoChanged,
                          },
                        }),
                        _vm.travelTimeConflicts.length > 0
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "text-red-600 text-sm mb-2 bg-red-50 border border-red-200 rounded-lg p-2",
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      `${
                                        _vm.selectedContractorData
                                          ? _vm.selectedContractorData?.user
                                              ?.given_name +
                                            " " +
                                            _vm.selectedContractorData?.user
                                              ?.family_name
                                          : "Selected Contractor"
                                      } has an earlier visit booked. Estimated travel time between visits may be an issue: ${_vm.travelTimeConflicts.join(
                                        ", "
                                      )}.`
                                    ) +
                                    " "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _c("TransportationMethodIcons", {
                          attrs: {
                            availableTransportation:
                              _vm.availableTransportationMethods,
                            showIcons: _vm.shouldShowTransportationIcons,
                            travelTimes: _vm.travelTimesToPreviousVisit,
                            hasOverlappingVisit:
                              _vm.hasOverlappingWithPreviousVisit,
                            conflictingMethods: _vm.travelTimeConflicts,
                          },
                        }),
                        _c(
                          "FormGroup",
                          {
                            staticClass: "mb-4",
                            attrs: { title: "Required Skills" },
                          },
                          [
                            _c("CustomSkillsMultiselectNew", {
                              key: _vm.skillsComponentKey,
                              attrs: {
                                previouslyChosenSkillsIds: _vm.skillsIds,
                                max: 25,
                                customSkillLabel:
                                  "Select or type to add new skill",
                                newSkillLabel: "Add new skill",
                                getParentContainer: "customWidthInput",
                              },
                              on: {
                                skillsListUpdated: _vm.handleSkillsListUpdated,
                              },
                            }),
                          ],
                          1
                        ),
                        _vm.shouldShowSkillsErrorNotifications
                          ? _c("VisitErrorNotificationContainer", {
                              staticClass: "mb-4",
                              attrs: {
                                errors: _vm.skillsValidationErrors,
                                show: _vm.shouldShowSkillsErrorNotifications,
                              },
                            })
                          : _vm._e(),
                        _c(
                          "FormGroup",
                          {
                            staticClass: "mb-4",
                            attrs: { title: "Soft Skills" },
                          },
                          [
                            _c("CustomSoftSkillsMultiselectNew", {
                              key: _vm.softSkillsComponentKey,
                              attrs: {
                                previouslyChosenSoftSkillsIds:
                                  _vm.softSkillsIds,
                                max: 25,
                                customSoftSkillLabel:
                                  "Select or type to add new soft skill",
                                newSoftSkillLabel: "Add new soft skill",
                                getParentContainer: "customWidthInput",
                              },
                              on: {
                                softSkillsListUpdated:
                                  _vm.handleSoftSkillsListUpdated,
                              },
                            }),
                          ],
                          1
                        ),
                        _vm.shouldShowSoftSkillsErrorNotifications
                          ? _c("VisitErrorNotificationContainer", {
                              staticClass: "mb-4",
                              attrs: {
                                errors: _vm.softSkillsValidationErrors,
                                show: _vm.shouldShowSoftSkillsErrorNotifications,
                              },
                            })
                          : _vm._e(),
                        _c("ValidationProvider", {
                          staticClass: "w-full",
                          attrs: {
                            name: "Description",
                            rules: "",
                            delay: "1000",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function ({ errors }) {
                                  return [
                                    _c(
                                      "FormGroup",
                                      {
                                        staticClass: "mb-4",
                                        attrs: {
                                          title: "Description",
                                          errors: errors,
                                        },
                                      },
                                      [
                                        _c("FormTextarea", {
                                          attrs: {
                                            rows: 3,
                                            customBorderClass: "borderTen",
                                            placeholder: "Type here",
                                            disabled: _vm.isEdittingLocked,
                                          },
                                          model: {
                                            value: _vm.activity.note,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.activity,
                                                "note",
                                                $$v
                                              )
                                            },
                                            expression: "activity.note",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                      ],
                      1
                    ),
                    _c("ValidationProvider", {
                      staticClass: "w-full",
                      attrs: { name: "Notes", rules: "", delay: "1000" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ errors }) {
                              return [
                                _c(
                                  "FormGroup",
                                  { attrs: { title: "Notes", errors: errors } },
                                  [
                                    _c("FormTextarea", {
                                      attrs: {
                                        rows: 3,
                                        name: "Notes",
                                        placeholder: "Type here",
                                        customBorderClass: "borderTen",
                                        disabled: _vm.isEdittingLocked,
                                      },
                                      model: {
                                        value: _vm.activity.extra_notes,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.activity,
                                            "extra_notes",
                                            $$v
                                          )
                                        },
                                        expression: "activity.extra_notes",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                    _vm._t("activity_actions_slot"),
                    _c(
                      "div",
                      { staticClass: "flex pt-5 justify-end" },
                      [
                        _vm.show_cancel_draft_actions
                          ? [
                              _vm.isActiveProject
                                ? _c("UiButton", {
                                    staticClass: "mr-3",
                                    attrs: {
                                      processing: _vm.statusProcessing,
                                      variant: "outline",
                                      buttonText: "Cancel",
                                      buttonClasses: "customButtonCard",
                                      size: "lg",
                                    },
                                    on: { click: _vm.closeModal },
                                  })
                                : _c("UiButton", {
                                    staticClass: "mr-3",
                                    attrs: {
                                      processing: _vm.statusProcessing,
                                      variant: "outline",
                                      disabled: invalid || _vm.isLoading,
                                      fullWidth: true,
                                      id: "draftProject",
                                      buttonClasses: "customButtonCard",
                                      buttonText: "Save as draft",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return handleSubmit(
                                          _vm.submitWithDraft,
                                          false
                                        )
                                      },
                                    },
                                  }),
                            ]
                          : _vm._e(),
                        !!_vm.projectActivity
                          ? _c("UiButton", {
                              attrs: {
                                processing: _vm.statusProcessing,
                                disabled:
                                  invalid ||
                                  _vm.isEdittingLocked ||
                                  _vm.isLoading,
                                buttonClasses: "customButtonCard",
                                buttonText: _vm.buttonText,
                                variant: "black",
                                size: "lg",
                              },
                              on: {
                                click: function ($event) {
                                  return handleSubmit(_vm.submit, false)
                                },
                              },
                            })
                          : _c("UiButton", {
                              attrs: {
                                processing: _vm.statusProcessing,
                                disabled: invalid || !dirty || _vm.isLoading,
                                buttonText: _vm.buttonText,
                                buttonClasses: "customButtonCard",
                                variant: "black",
                                size: "lg",
                              },
                              on: {
                                click: function ($event) {
                                  return handleSubmit(_vm.submit, false)
                                },
                              },
                            }),
                      ],
                      2
                    ),
                  ]
                },
              },
            ],
            null,
            true
          ),
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }